import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('PriceWithPromotions');

const propTypes = {
    className: PropTypes.string,
    originalPrice: PropTypes.string,
    promotions: PropTypes.arrayOf(
        PropTypes.shape({
            code: PropTypes.string.isRequired,
            amount: PropTypes.string.isRequired
        })
    ).isRequired,
    finalPrice: PropTypes.string.isRequired,
    taxesAndDuties: PropTypes.shape({
        taxAmount: PropTypes.string.isRequired,
        dutiesAmount: PropTypes.string.isRequired
    }),
    lineLevelTaxesEnabled: PropTypes.bool,
    DDPIncludedCountry: PropTypes.bool,
    DDPCountry: PropTypes.bool,
    shipping: PropTypes.bool,
    isMarkdownPrice: PropTypes.bool
};

Price.propTypes = propTypes;

export const Price = props => {
    const {
        className,
        originalPrice,
        promotions = [],
        taxesAndDuties,
        salesTax,
        finalPrice,
        DDPIncludedCountry,
        priceReduced,
        messages,
        isMarkdownPrice,
        markedDownPrice,
        markedDownPercentDiscount,
        adjustedOrderItemPrice,
        shipping
    } = props;
    const hasPromotion = !!promotions.length;
    const hasMarkdown = isMarkdownPrice || !!markedDownPercentDiscount;

    return (
        <div className={bem(null, { extraHeight: hasPromotion || taxesAndDuties }, className)}>
            <div className={bem('promoWrapper')}>
                {markedDownPrice !== adjustedOrderItemPrice && <div className={bem('promoPrice')}>{adjustedOrderItemPrice}</div>}

                {hasPromotion &&
                    promotions.map(({ code, description }) => (
                        <div className={bem('promotion')} key={code}>
                            {messages.price.promoApplied({ description })}
                        </div>
                    ))}
            </div>

            {originalPrice && (
                <div className={bem('originalPriceWithDiscount')}>
                    <span className={bem('originalPrice', { onlyPrice: !adjustedOrderItemPrice }, { priceReduced })}>{originalPrice}</span>
                    {markedDownPercentDiscount && (
                        <span className={bem('percentDiscount')}> {messages.price.discountPercentage({ discountPercentage: markedDownPercentDiscount })}</span>
                    )}
                </div>
            )}
            {markedDownPrice ? <div className={bem('markedDownPrice', shipping && 'shipping', { priceReduced: hasPromotion })}>{markedDownPrice}</div> : null}

            {taxesAndDuties && (
                <>
                    <div className={bem('tax')}>
                        {messages.price.itemTax({ included: !!DDPIncludedCountry })}
                        <span className={bem('taxPrice')}>{taxesAndDuties.taxAmount}</span>
                    </div>
                    <div className={bem('duties')}>
                        {messages.price.duties({ included: !!DDPIncludedCountry })}
                        <span className={bem('taxPrice')}>{taxesAndDuties.dutiesAmount}</span>
                    </div>
                </>
            )}
            {salesTax && (
                <div className={bem('salesTax')}>
                    {messages.price.salesTax()}
                    {salesTax}
                </div>
            )}
            {finalPrice ? <div className={bem('finalPrice', shipping && 'shipping', { hasMarkdown })}>{finalPrice}</div> : null}
        </div>
    );
};

export default Price;
